import { endpoints } from "../config/endpoints.js";
import initNews from "../modules/news.js";

export default function initNewsFeed(root = document) {
  console.log("INIT News Feed RUNNING");

  const modules = root.querySelectorAll("[data-module='news-feed']");
  if (!modules.length) return;

  modules.forEach(async (module) => {
    if (module.dataset.newsFeedInitialised === "true") return;
    module.dataset.newsFeedInitialised = "true";

    try {
      const res = await fetch(endpoints.newsFeed, {
        cache: "no-store",
      });

      if (!res.ok) throw new Error("Failed to load news");

      const html = await res.text();

      if (!html.trim()) {
        module.innerHTML = "";
        return;
      }
      
      module.innerHTML = html;

      initNews(module);

    } catch (err) {
      console.warn("News feed failed:", err);
      module.innerHTML = "<p>News is currently unavailable.</p>";
    }
  });
}